<template>
  <div>
    <b-card style="margin:1%">
      <b-col style="margin:5px">
        <b-button @click.stop="showSelectDocuments" variant="success">{{ $t('Add') }}</b-button>
      </b-col>
      <b-table small striped hover :items="documents" :fields="fieldsDocuments" @row-clicked="rowClickHandler">
        <template v-slot:cell(uploaded)="data">
          <b-form-checkbox disabled v-model="data.value"/>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="ClickOnDownloadContractButton(row)" id="transparent">
            <b-img :src='downloagDocumentImage' />
          </b-button>
          <b-button size="sm" @click.stop="ClickOnDeleteDocumentsButton(row)" id="transparent">
            <b-img :src='deleteDocumentImage' />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteDocuments">
      <h5>{{ $t('Are you sure you want to delete one of "Documents"?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteDocuments()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideDeleteDocuments()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="selectDocuments" hide-footer :title="$t('New contract')" @hidden="isShowSelectDocuments = false">
      <FormSelectDocuments v-if="isShowSelectDocuments" :currentRow="currentRow" @refreshTable="refreshTable" @hideSelectDocuments="hideSelectDocuments" @makeToasts="makeToasts"></FormSelectDocuments>
    </b-modal>
  </div>
</template>

<script>

import download from 'downloadjs'
import axiosInstance from '@/utils/api.js'
import moment from 'moment'
import FormSelectDocuments from './formSelectDocuments'

export default {
  components: {
    FormSelectDocuments
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      fileName: '',
      isShowSelectDocuments: false,
      downloagDocumentImage: require('@/assets/img/download.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      documents: [],
      fieldsDocuments: [
        { key: 'contract_id', label: this.$i18n.t('Documents ID'), sortable: true },
        { key: 'template_id', label: this.$i18n.t('Template ID'), sortable: true },
        { key: 'created', label: this.$i18n.t('Date of creation'), sortable: true },
        { key: 'name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'path', label: this.$i18n.t('Path'), sortable: true },
        { key: 'typeFile', label: this.$i18n.t('Type'), sortable: true },
        { key: 'uploaded', label: this.$i18n.t('Uploaded'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ]
    }
  },
  methods: {
    async load () {
      this.documents = await axiosInstance.get(this.$store.getters.API_USERS_CONTRACTS + '?user_id=' + this.currentRow.user_id).then(response => { return response.data })
      for (let i in this.documents) {
        this.documents[i].created = moment(Number(this.documents[i].created) * 1000).format('MM-DD-YYYY')
        this.documents[i].uploaded = JSON.parse(JSON.stringify(this.documents[i].template_id)) === 0
      }
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    rowClickHandler (row) {
      if (this.documents) {
        this.documents._rowVariant = ''
      }
      this.documents = row
      this.$set(this.documents, '_rowVariant', 'info')
    },
    ClickOnDeleteDocumentsButton (row) {
      this.documents = row.item
      this.$refs.modalDeleteDocuments.show()
    },
    hideDeleteDocuments () {
      this.$refs.modalDeleteDocuments.hide()
    },
    deleteDocuments () {
      if (this.documents) {
        axiosInstance.delete(this.$store.getters.API_USERS_CONTRACTS + '?contract_id=' + this.documents.contract_id)
        this.$root.$emit('makeToasts')
        this.$refs.modalDeleteDocuments.hide()
        this.load()
      }
    },
    showSelectDocuments () {
      this.isShowSelectDocuments = true
      this.$refs.selectDocuments.show()
    },
    hideSelectDocuments () {
      this.isShowSelectDocuments = false
      this.$refs.selectDocuments.hide()
    },
    refreshTable () {
      this.isShowSelectDocuments = false
      this.$refs.selectDocuments.hide()
      this.load()
    },
    ClickOnDownloadContractButton (row) {
      this.fileName = row.item.path
      let contractId = row.item.contract_id
      axiosInstance.get(this.$store.getters.API_USERS_CONTRACTS_DOWNLOAD + '?contract_id=' + contractId + '&is_conv=1', {
        responseType: 'blob'}).then(response => {
        download(response.data, this.fileName, 'application/pdf')
      })
    }
  },
  watch: {
    currentRow: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/documents/main.vue